import axios from "axios";
import { milestoneAcceptWorkUrl } from "../../utils";

export const milestoneAcceptWork = (projectId: string, milestoneId: string) => {
  return axios.post(milestoneAcceptWorkUrl(projectId, milestoneId));
};
